export const groupByMonth = (data) => {
    return [{ label: "", rides: 0, completed: 0, cancelled: 0, requests: 0, pending: 0 }, ...Object.values(data.reduce((acc, item) => {
        const date = new Date(item.trip_day);
        const monthKey = date.toISOString().slice(0, 7);
        const monthName = date.toLocaleString('default', { month: 'long' });

        if (!acc[monthKey]) {
            acc[monthKey] = { month: monthKey, label: monthName.slice(0, 4), rides: 0, completed: 0, cancelled: 0, requests: 0, pending: 0 };
        }

        acc[monthKey].rides += item.total_trips;
        acc[monthKey].completed += item.completed;
        acc[monthKey].cancelled += item.cancelled;
        acc[monthKey].requests += item.total_requests;
        acc[monthKey].pending += item.pending_requests;

        return acc;
    }, {}))]
};

const getWeekStartAndEnd = () => {
    const today = new Date();
    const startOfWeek = new Date(today);
    startOfWeek.setUTCHours(0, 0, 0, 0); // Set time to midnight
    startOfWeek.setDate(today.getDate() - today.getDay()); // Set to Monday
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6); // Set to Sunday

    return {
        startOfWeek,
        endOfWeek,
    };
};

export const groupByWeek = (data) => {
    const { startOfWeek, endOfWeek } = getWeekStartAndEnd();

    const result = data.reduce((acc, item) => {
        const tripDate = new Date(item.trip_day);

        // Only include data that falls within the current week (Monday to Sunday)
        if (tripDate >= startOfWeek && tripDate <= endOfWeek) {
            const dayOfWeek = tripDate.toLocaleString('en-US', { weekday: 'long' }); // Get day name (Monday, Tuesday, etc.)
            if (!acc[dayOfWeek]) {
                acc[dayOfWeek] = { label: dayOfWeek, rides: 0, completed: 0, cancelled: 0, requests: 0, pending: 0 };
            }
            acc[dayOfWeek].rides += item.total_trips;
            acc[dayOfWeek].completed += item.completed;
            acc[dayOfWeek].cancelled += item.cancelled;
            acc[dayOfWeek].requests += item.total_requests;
            acc[dayOfWeek].pending += item.pending_requests;
        }
        return acc;
    }, {});

    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const weekData = daysOfWeek.map(day => result[day] || { label: day, rides: 0, completed: 0, cancelled: 0, requests: 0, pending: 0 });

    return [...weekData];
};

export const groupByDay = (data) => {
    const today = new Date();

    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const normalizeDate = (date) => new Date(date).setHours(0, 0, 0, 0);

    const filteredData = data.filter(item => {
        const tripDate = new Date(item.trip_day);
        return normalizeDate(tripDate) >= normalizeDate(firstDayOfMonth) && normalizeDate(tripDate) <= normalizeDate(new Date(today).setDate(today.getDate() + 1));
    });

    // Group the filtered data by day
    const groupedData = filteredData.map(item => {
        const tripDate = new Date(item.trip_day);
        const day = tripDate.getDate(); // Get the day of the month
        return {
            label: String(day).padStart(2, ''),
            rides: item.total_trips,
            completed: item.completed,
            cancelled: item.cancelled,
            requests: item.total_requests,
            pending: item.pending_requests
        };
    });

    return [{ label: "", rides: 0, completed: 0, cancelled: 0, requests: 0, pending: 0 }, ...groupedData];
}